import { render, staticRenderFns } from "./EditHistory.vue?vue&type=template&id=c3fa3cce&scoped=true"
import script from "./EditHistory.vue?vue&type=script&lang=js"
export * from "./EditHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fa3cce",
  null
  
)

export default component.exports